import { useState } from "react";
import { Link } from "react-router-dom";
import { LayoutDashboard, Package, ClipboardList, Store, LogOut, FileImage, MessageSquareText, UserCog, Users, Building2, FileText, Crown, UserRound } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminArts from "@/pages/admin/AdminArts";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminAccount from "@/pages/admin/AdminAccount";
import AdminResellers from "@/pages/admin/AdminResellers";
import AdminCompany from "@/pages/admin/AdminCompany";
import AdminQuote from "@/pages/admin/AdminQuote";
import AdminVips from "@/pages/admin/AdminVips";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import { PaymentAlerts } from "@/components/PaymentAlerts";

const TABS = [
  ["dashboard", "Painel", LayoutDashboard],
  ["orders", "Pedidos", ClipboardList],
  ["quotes", "Orçamentos", FileText],
  ["arts", "Artes", FileImage],
  ["products", "Produtos", Package],
  ["resellers", "Revendedores", Users],
  ["customers", "Clientes", UserRound],
  ["vips", "Clientes VIP", Crown],
  ["stores", "Lojas", Store],
  ["settings", "Mensagens", MessageSquareText],
  ["company", "Empresa", Building2],
  ["account", "Minha conta", UserCog],
];

export default function AdminPage() {
  const [tab, setTab] = useState("dashboard");
  const { logout } = useAuth();

  return (
    <div className="flex min-h-screen flex-col bg-slate-50 md:flex-row">
      <aside className="flex shrink-0 flex-col gap-6 bg-slate-900 p-5 text-slate-300 md:w-60 md:min-h-screen" data-testid="admin-sidebar">
        <Logo dark to="/admin" />
        <nav className="grid grid-cols-2 gap-1 sm:grid-cols-3 md:flex md:flex-col" data-testid="admin-nav">
          {TABS.map(([key, label, Icon]) => (
            <button key={key} onClick={() => setTab(key)} data-testid={`admin-tab-${key}`}
              className={`flex min-w-0 items-center gap-2 rounded-md px-3 py-2 text-sm font-semibold transition-colors md:gap-3 md:py-2.5 ${tab === key ? "bg-white/10 text-white" : "hover:bg-white/5 hover:text-white"}`}>
              <Icon className="h-4 w-4 shrink-0" /> <span className="truncate">{label}</span>
            </button>
          ))}
        </nav>
        <div className="mt-auto flex gap-1 md:flex-col">
          <Link to="/" className="flex items-center gap-3 rounded-md px-3 py-2 text-sm hover:text-white" data-testid="admin-view-store"><Store className="h-4 w-4" /> Ver loja</Link>
          <button onClick={logout} className="flex items-center gap-3 rounded-md px-3 py-2 text-sm hover:text-white" data-testid="admin-logout"><LogOut className="h-4 w-4" /> Sair</button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden p-4 sm:p-8">
        <PaymentAlerts onOpenOrders={() => setTab("orders")} />
        {tab === "dashboard" && <AdminDashboard onOpenOrders={() => setTab("orders")} />}
        {tab === "orders" && <AdminOrders />}
        {tab === "products" && <AdminProducts />}
        {tab === "arts" && <AdminArts />}
        {tab === "settings" && <AdminMessages />}
        {tab === "account" && <AdminAccount />}
        {tab === "resellers" && <AdminResellers />}
        {tab === "stores" && <AdminResellers kind="stores" />}
        {tab === "quotes" && <AdminQuote />}
        {tab === "vips" && <AdminVips />}
        {tab === "customers" && <AdminCustomers />}
        {tab === "company" && <AdminCompany />}
      </main>
    </div>
  );
}
